export type GenericPageBackgroundImageSize = 'cover' | 'full-width';

export function normalizeGenericPageBackgroundImageSize(
  value: unknown,
): GenericPageBackgroundImageSize {
  if (value === 'full-width') {
    return 'full-width';
  }
  return 'cover';
}

export function genericPageBackgroundSizeCss(
  size: GenericPageBackgroundImageSize,
): string | null {
  return size === 'full-width' ? '100% auto' : 'cover';
}
